import store from './../store/index'
import router from './../router/index'

function logout () {
  store.dispatch('logOut')

  if (router.history.current.path !== '/') {
    router.push('/')
  }
}

// Экран обслуживания показываем поверх текущей страницы, не меняя адрес.
// Почему не переход на /503 — см. комментарий в utils/httpInterceptor.js
// (RBXGD-1119). Ключ route_before_503 отсюда убран: его писали в двух местах и
// нигде не читали, а без смены маршрута возвращаться и вовсе некуда.
function handleServiceUnavailable () {
  store.commit('setServiceUnavailable', true)
}

const get = async (url, jwt = null, headers = null) => {
  const reqHeaders = new Headers()

  if (headers) {
    Object.keys(headers).forEach((k) => {
      reqHeaders.append(k, headers[k])
    })
  }

  if (jwt) {
    reqHeaders.append('Authorization', `Bearer ${jwt}`)
  }

  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: reqHeaders
    })

    if (response.status === 401) {
      logout()
    }

    if (response.status === 503) {
      handleServiceUnavailable()
    }

    const data = await response.json()

    return {
      statusCode: response.status,
      data,
      error: null
    }
  } catch (err) {
    return {
      statusCode: 0,
      data: {},
      error: err
    }
  }
}

const post = async (url, body, jwt = null, headers = null) => {
  const reqHeaders = new Headers()

  reqHeaders.append('Content-Type', 'application/json')

  if (headers) {
    Object.keys(headers).forEach((k) => {
      reqHeaders.append(k, headers[k])
    })
  }

  if (jwt) {
    reqHeaders.append('Authorization', `Bearer ${jwt}`)
  }

  try {
    const response = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: reqHeaders
    })

    if (response.status === 401) {
      logout()
    }

    if (response.status === 503) {
      handleServiceUnavailable()
    }

    const data = await response.json()

    return {
      statusCode: response.status,
      data
    }
  } catch (err) {
    return {
      statusCode: 0,
      data: {},
      error: err
    }
  }
}

const put = async (url, body, jwt = null) => {
  const reqHeaders = new Headers()

  reqHeaders.append('Content-Type', 'application/json')

  if (jwt) {
    reqHeaders.append('Authorization', `Bearer ${jwt}`)
  }

  try {
    const response = await fetch(url, {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: reqHeaders
    })

    if (response.status === 401) {
      logout()
    }

    if (response.status === 503) {
      handleServiceUnavailable()
    }

    const data = await response.json()

    return {
      statusCode: response.status,
      data
    }
  } catch (err) {
    return {
      statusCode: 0,
      data: {},
      error: err
    }
  }
}

const patch = async (url, body, jwt = null, headers = null) => {
  const reqHeaders = new Headers()

  reqHeaders.append('Content-Type', 'application/json')

  if (headers) {
    Object.keys(headers).forEach((k) => {
      reqHeaders.append(k, headers[k])
    })
  }

  if (jwt) {
    reqHeaders.append('Authorization', `Bearer ${jwt}`)
  }

  try {
    const response = await fetch(url, {
      method: 'PATCH',
      body: JSON.stringify(body),
      headers: reqHeaders
    })

    if (response.status === 401) {
      logout()
    }

    if (response.status === 503) {
      handleServiceUnavailable()
    }

    const data = await response.json()

    return {
      statusCode: response.status,
      data
    }
  } catch (err) {
    return {
      statusCode: 0,
      data: {},
      error: err
    }
  }
}

export default { get, post, put, patch }
